import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

// action types
export const VERIFY_AUTH = "verifyAuth";
export const LOGIN = "login";
export const LOGOUT = "logout";
export const REGISTER = "register";
export const UPDATE_PASSWORD = "updateUser";
export const GET_EMITENTE_PRINCIPAL = "getEmitentePrincipal";
export const GET_USUARIOS_EMITENTE = "getUsuariosEmitente";
export const UPDATE_USUARIOS_EMITENTE = "updateUsuariosEmitente";
export const GET_USUARIOS = "getUsuarios";
export const GET_USUARIO = "getUsuario";
export const GET_VERIFICAR_EMAIL_LIVRE = "verificarEmailLivre";
export const UPDATE_INATIVAR_USUARIO = "inativarUsuario";
export const UPDATE_ZERAR_QUANTIDADES_TENTATIVAS = "zerarQuantidadesTentativas";
export const GET_PERMISSOES = "getPermissoes";
export const GET_AUTORIZACAO_PERMISSAO = "getAutorizacaoPermissao";
export const UPDATE_ALTERAR_SENHA_USUARIO = "updateAlterarSenhaUsuario";
export const GET_LOGS_ACESSO = "getLogsAcesso";
export const GET_CONFIGURACOES = "getConfiguracoes";
export const UPDATE_CONFIGURACOES = "updateConfiguracoes";
export const UPDATE_PAGAR_TITULO = "updatePagarTitulo";
export const GET_LINK_ACESSO_AGENDAMENTO = "getLinkAcessoAgendamento";

// mutation types
export const PURGE_AUTH = "logOut";
export const SET_AUTH = "setUser";
export const SET_PASSWORD = "setPassword";
export const SET_ERROR = "setError";
export const SET_VERIFICADO = "setVerificado";
export const SET_EMITENTE_PRINCIPAL = "setEmitentePrincipal";
export const SET_USUARIOS_EMITENTE = "setUsuariosEmitente";
export const SET_USUARIOS = "setUsuarios";
export const SET_USUARIO = "setUsuario";
export const SET_PERMISSOES = "setPermissoes";
export const SET_CONFIGURACOES = "setConfiguracoes";

const state = {
    errors: null,
    user: {},
    isAuthenticated: !!JwtService.getToken(),
    verificado: false,
    emitentePrincipal: {},
    autorizadoComunicado: false,
    usuariosEmitente: [],
    usuarios: [],
    usuario: {},
    permissoes: [],
    configuracoes: []
};

const getters = {
    currentUser(state) {
        return state.user;
    },
    isAuthenticated(state) {
        return state.isAuthenticated;
    },
    verificado(state) {
        return state.verificado;
    },
    emitentePrincipal(state) {
        return state.emitentePrincipal;
    },
    usuariosEmitente(state) {
        return state.usuariosEmitente;
    },
    usuarios(state) {
        return state.usuarios;
    },
    usuario(state) {
        return state.usuario;
    },
    permissoes(state) {
        return state.permissoes;
    },
    configuracoes(state) {
        return state.configuracoes;
    }
};

const actions = {
    [LOGIN](context, credentials) {
        return new Promise(resolve => {
            ApiService.post("login", credentials)
                .then(({ data }) => {
                    if (data.resultado) {
                        context.commit(SET_AUTH, data);
                    }
                    resolve(data);
                })
                .catch(({ response }) => {
                    context.commit(SET_ERROR, response.data.errors);
                });
        });
    },
    [LOGOUT](context) {
        context.commit(PURGE_AUTH);
    },
    [REGISTER](context, credentials) {
        return new Promise(resolve => {
            ApiService.post("login", credentials)
                .then(({ data }) => {
                    context.commit(SET_AUTH, data);
                    resolve(data);
                })
                .catch(({ response }) => {
                    context.commit(SET_ERROR, response.data.errors);
                });
        });
    },
    [VERIFY_AUTH](context) {
        if (JwtService.getToken()) {
            ApiService.setHeader();
            ApiService.get("verify")
                .then(({ data }) => {
                    if (data.resultado) {
                        context.commit(SET_AUTH, data);
                        context.commit(SET_VERIFICADO, true);
                    } else {
                        context.commit(PURGE_AUTH);
                        window.dispatchEvent(new Event("naoAutorizado"));
                    }
                })
                .catch(({ response }) => {
                    context.commit(SET_ERROR, response.data.errors);
                    context.commit(PURGE_AUTH);
                });
        } else {
            context.commit(PURGE_AUTH);
        }
    },
    [UPDATE_PASSWORD](context, payload) {
        const password = payload;

        return ApiService.put("password", password).then(({ data }) => {
            context.commit(SET_PASSWORD, data);
            return data;
        });
    },
    [GET_EMITENTE_PRINCIPAL](context) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.get("emitentePrincipal").then(({ data }) => {
                    context.commit(SET_EMITENTE_PRINCIPAL, data);
                    resolve(data);
                });
            }
        });
    },
    [GET_USUARIOS_EMITENTE](context, idEmitenteUsuario) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.get("usuariosSecurity/" + idEmitenteUsuario).then(
                    ({ data }) => {
                        context.commit(SET_USUARIOS_EMITENTE, data);
                        resolve(data);
                    }
                );
            }
        });
    },
    [UPDATE_USUARIOS_EMITENTE](context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("incluirUsuario", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    [GET_USUARIOS](context) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.get("usuarios").then(({ data }) => {
                    context.commit(SET_USUARIOS, data);
                    resolve(data);
                });
            }
        });
    },
    [GET_USUARIO](context, idEmitenteMLUsuario) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.get("usuario/" + idEmitenteMLUsuario).then(({ data }) => {
                    context.commit(SET_USUARIO, data);
                    resolve(data);
                });
            }
        });
    },
    [GET_VERIFICAR_EMAIL_LIVRE](context, email) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("verificarEmailLivre", { email: email }).then(
                    ({ data }) => {
                        resolve(data);
                    }
                );
            }
        });
    },
    [UPDATE_INATIVAR_USUARIO](context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("inativarUsuario", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    [UPDATE_ZERAR_QUANTIDADES_TENTATIVAS](context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("zerarQuantidadesTentativas", dados).then(
                    ({ data }) => {
                        resolve(data);
                    }
                );
            }
        });
    },
    [GET_PERMISSOES](context) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.get("permissoes").then(({ data }) => {
                    context.commit(SET_PERMISSOES, data.PERMISSOES);
                    resolve(data);
                });
            }
        });
    },
    [GET_AUTORIZACAO_PERMISSAO](context, codigo) {
        return new Promise(resolve => {
            let autorizado = false;

            context.state.permissoes.forEach(function(permissao) {
                if (
                    (permissao.CODIGO == codigo && permissao.PERMISSAO == 1) ||
                    (permissao.CODIGO == "MASTER" && permissao.PERMISSAO == 1)
                ) {
                    autorizado = true;
                }
            });

            resolve(autorizado);
        });
    },
    [UPDATE_ALTERAR_SENHA_USUARIO](context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("alterarSenha", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    [GET_LOGS_ACESSO](context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.get(
                    "logsAcesso/" + dados.quantidade + "/" + dados.quantidadeExibir
                ).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    [GET_CONFIGURACOES](context) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.get("configuracoes").then(({ data }) => {
                    context.commit(SET_CONFIGURACOES, data);
                    resolve(data);
                });
            }
        });
    },
    [UPDATE_CONFIGURACOES](context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("salvarConfiguracoes", dados).then(({ data }) => {
                    context.commit(SET_CONFIGURACOES, data);
                    resolve(data);
                });
            }
        });
    },
    [UPDATE_PAGAR_TITULO](context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("pagarTitulo", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    [GET_LINK_ACESSO_AGENDAMENTO]() {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.get("gerarLinkAcessoAgendamento").then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }
};

const mutations = {
    [SET_ERROR](state, error) {
        state.errors = error;
    },
    [SET_AUTH](state, user) {
        state.isAuthenticated = true;
        state.errors = {};

        if (user.token) {
            state.user = user;
            JwtService.saveToken(state.user.token);
        }
    },
    [SET_VERIFICADO](state, verificado) {
        state.verificado = verificado;
        if (!state.autorizadoComunicado) {
            setTimeout(function() {
                window.dispatchEvent(new Event("autorizado"));
            }, 1000);
            state.autorizadoComunicado = !state.autorizadoComunicado;
        }
    },
    [SET_PASSWORD](state, password) {
        state.user.password = password;
    },
    [SET_EMITENTE_PRINCIPAL](state, emitentePrincipal) {
        state.emitentePrincipal = emitentePrincipal;
    },
    [SET_USUARIOS_EMITENTE](state, usuariosEmitente) {
        state.usuariosEmitente = usuariosEmitente;
    },
    [SET_USUARIOS](state, usuarios) {
        state.usuarios = usuarios;
    },
    [SET_USUARIO](state, usuario) {
        state.usuario = usuario;
    },
    [PURGE_AUTH](state) {
        state.isAuthenticated = false;
        state.user = {};
        state.errors = {};
        JwtService.destroyToken();
    },
    [SET_PERMISSOES](state, permissoes) {
        state.permissoes = permissoes;
    },
    [SET_CONFIGURACOES](state, configuracoes) {
        state.configuracoes = configuracoes;
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};